import {
  formation343,
  formation352,
  formation433,
  formation442,
  formation451,
  formation532,
  formation541,
  formation4231,
  formation4411,
  formation41212,
  standardDimensionsFull,
} from "../../../config/soccer/sets";
import set343 from "./3-4-3.svg";
import set352 from "./3-5-2.svg";
import set41212 from "./4-1-2-1-2.svg";
import set4231 from "./4-2-3-1.svg";
import set433 from "./4-3-3.svg";
import set4411 from "./4-4-1-1.svg";
import set442 from "./4-4-2.svg";
import set451 from "./4-5-1.svg";
import set532 from "./5-3-2.svg";
import set541 from "./5-4-1.svg";

const set343Label = formation343(standardDimensionsFull).label;
const set352Label = formation352(standardDimensionsFull).label;
const set41212Label = formation41212(standardDimensionsFull).label;
const set4231Label = formation4231(standardDimensionsFull).label;
const set433Label = formation433(standardDimensionsFull).label;
const set4411Label = formation4411(standardDimensionsFull).label;
const set442Label = formation442(standardDimensionsFull).label;
const set451Label = formation451(standardDimensionsFull).label;
const set532Label = formation532(standardDimensionsFull).label;
const set541Label = formation541(standardDimensionsFull).label;

export const soccerSetNameToThumbnailMap = new Map([
  [set343Label, set343],
  [set352Label, set352],
  [set41212Label, set41212],
  [set4231Label, set4231],
  [set433Label, set433],
  [set4411Label, set4411],
  [set442Label, set442],
  [set451Label, set451],
  [set532Label, set532],
  [set541Label, set541],
]);
